import React, { Component, PropsWithChildren } from 'react';

interface IProps extends PropsWithChildren<{}> {}

export default class DialogFooter extends Component<IProps> {
    public render() {
        return (
            <div className="dialog-footer">
                <div className="dialog-footer-options">
                    {this.props.children}
                </div>
            </div>
        );
    }
}
